// FICHIER GÉNÉRÉ — NE PAS ÉDITER À LA MAIN.
//
// Produit par `npm run gen:api` depuis shared/openapi.json, lui-même produit
// depuis le code réel de api/. Toute modification manuelle sera écrasée sans
// avertissement à la prochaine génération.
//
// Pour changer ce fichier : corriger le contrat côté api/ (décorateurs OpenAPI,
// DTO de réponse) ou shared/openapi-ts.config.ts, puis régénérer.
// This file is auto-generated by @hey-api/openapi-ts
import { client } from './client.gen.js';
import { formDataBodySerializer } from './client/index.js';
/**
 * Racine de l'API versionnée
 *
 * Sert à vérifier qu'un déploiement répond bien sous /api/v1. Route d'exemple : un projet dérivé la remplace par ses routes métier.
 */
export const getRoot = (options) => (options?.client ?? client).get({ url: '/api/v1', ...options });
/**
 * Ouvrir une session
 *
 * Écran unique pour les quatre rôles. La réponse est identique que l'adresse ait un compte ou non, et le temps de réponse aussi. La session dure sept jours.
 */
export const connexion = (options) => (options.client ?? client).post({
    url: '/api/v1/auth/connexion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Fermer la session courante
 *
 * Révocation côté serveur, et non un simple oubli côté client : le jeton cesse immédiatement de valoir. La ligne de session est conservée, datée.
 */
export const deconnexion = (options) => (options?.client ?? client).post({ url: '/api/v1/auth/deconnexion', ...options });
/**
 * Lire son compte et sa session
 *
 * Ne rend que le compte de la personne connectée. « accesPerdu » vaut vrai quand plus aucun rattachement n'est actif : la personne entre, trouve un espace vide qui l’avertit, et tout geste de cours lui est refusé.
 */
export const sessionCourante = (options) => (options?.client ?? client).get({ url: '/api/v1/auth/session', ...options });
/**
 * Demander un code
 *
 * Mécanisme unique : il sert l'activation d'un compte comme la réinitialisation. La réponse est identique que l'adresse ait un compte ou non. Le code vaut dix minutes, un seul usage, et il est brûlé à la sixième présentation. Les demandes sont plafonnées par compte et par heure.
 */
export const motDePasseOublie = (options) => (options.client ?? client).post({
    url: '/api/v1/auth/mot-de-passe-oublie',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Poser son mot de passe
 *
 * Ouverte au porteur d’un billet rendu par POST /api/v1/acces/:valeur. La pose passe le compte en actif, ferme toutes ses connexions antérieures, et ouvre une session de sept jours.
 */
export const poseMotDePasseInitial = (options) => (options.client ?? client).post({
    url: '/api/v1/auth/mot-de-passe/initial',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Changer son mot de passe
 *
 * Exige le mot de passe courant. Toutes les autres connexions du compte sont fermées ; la session qui fait le changement reste ouverte.
 */
export const changerMotDePasse = (options) => (options.client ?? client).post({
    url: '/api/v1/auth/mot-de-passe',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Santé de l'API
 *
 * Destinée à un moniteur externe. Ne teste pas la base : une base momentanément indisponible ne doit pas faire redémarrer le conteneur en boucle. N'exige aucune authentification et ignore le contrôle de version cliente.
 */
export const getHealth = (options) => (options?.client ?? client).get({ url: '/api/health', ...options });
/**
 * Présenter un code ou un lien d’auto-connexion
 *
 * La valeur est soit un code à huit caractères — l’adresse email est alors requise dans le corps —, soit un jeton de lien d’auto-connexion. Un code de changement d’adresse fait prendre le changement effet. Sur un compte sans mot de passe, aucune session n’est ouverte : un billet est rendu, et la pose du mot de passe est obligatoire avant l’entrée.
 */
export const presenterUnAcces = (options) => (options.client ?? client).post({
    url: '/api/v1/acces/{valeur}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Annuler l’accès d’une personne à un cours
 *
 * ANNULE TOUT CE QUI VAUT ENCORE POUR CE COUPLE — un accès réémis laisserait sinon un second lien valide après un geste qui annonce l’avoir annulé. Un tuteur sur son cours, un orgadmin sur les cours de sa structure, une structure par son secret, le compte qui voit tout. Un appel présentant un secret est refusé quand la personne est PRÉSENTE dans le cours — « un cours commencé va à son terme ». LE GESTE NE NOMME JAMAIS UN LIEN : ce qu’il désigne est une personne et un cours, et c’est ce qui tient F-59.
 */
export const revoquerUnAcces = (options) => (options.client ?? client).delete({ url: '/api/v1/acces/cours/{coursId}/personnes/{personneId}', ...options });
/**
 * Demander un changement d’adresse
 *
 * Exige le mot de passe courant, puis envoie un code à la NOUVELLE adresse. L’adresse du compte reste inchangée jusqu’à ce que ce code soit présenté à POST /api/v1/acces/:valeur. Refusé tant que l’adresse courante n’a jamais été prouvée.
 */
export const demanderChangementAdresse = (options) => (options.client ?? client).post({
    url: '/api/v1/compte/adresse',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Anonymiser un compte
 *
 * Le seul geste destructif du produit, et il est irréversible. Trois humains le déclenchent : la personne sur elle-même, un orgadmin seulement si sa structure est le dernier rattachement actif, le compte qui voit tout — qui ne l’exerce pas sur lui-même. Un secret d’appel ne le déclenche jamais. L’email part AVANT l’effacement des adresses.
 */
export const anonymiserUnCompte = (options) => (options.client ?? client).post({
    url: '/api/v1/comptes/{id}/anonymisation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Créer ou rattacher un compte
 *
 * Cinq champs, liste fermée. L’adresse est la clé de reconnaissance, et seulement au moment du provisionnement : une adresse connue — présente ou passée — retrouve son compte au lieu d’en créer un second. Deux appels identiques à moins de trente secondes n’en font qu’un, et le second rend un succès portant la mention du rejeu. Un email d’activation part à chaque création.
 */
export const provisionnerUnCompte = (options) => (options.client ?? client).post({
    url: '/api/v1/provisionnement/comptes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Importer des comptes par fichier
 *
 * CSV, séparateur point-virgule, en-tête nom;prenom;email;role;identifiantExterne. Cinq cents lignes au minimum doivent tenir. Une seule ligne invalide refuse le fichier entier, et toutes les erreurs sont rendues d’un coup. Rejouable sans doublon. AUCUN EMAIL NE PART, quel que soit le nombre de lignes. Une ligne de trace est écrite, sans le contenu du fichier.
 */
export const importerDesComptes = (options) => (options.client ?? client).post({
    url: '/api/v1/provisionnement/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Mettre deux personnes en relation
 *
 * La relation est le préalable à toute séance, à tout partage de dossier et à toute conversation. Une seule ligne par couple, pour toujours : une relation recréée réécrit la ligne existante, et ni l’ancienne conversation ni l’ancien partage ne reviennent. Les deux personnes reçoivent un email. LA STRUCTURE CRÉATRICE EST CELLE DE L’APPELANT, jamais un paramètre : une structure par son secret, ou la personne qui tient son espace. Le compte qui voit tout n’a pas ce geste — il n’a aucun rattachement, donc il ne désigne aucune structure créatrice, ce que F-08 exige (amendé le 20260826, D-101).
 */
export const creerUneRelation = (options) => (options.client ?? client).post({
    url: '/api/v1/provisionnement/relations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Défaire une relation
 *
 * Un orgadmin ne défait que ce que sa structure a créé — et la structure créatrice est la DERNIÈRE, une recréation la réécrivant. La personne restée voit un message disant que son correspondant n’est plus joignable, identique quelle que soit la cause.
 */
export const fermerUneRelation = (options) => (options.client ?? client).delete({ url: '/api/v1/provisionnement/relations/{id}', ...options });
/**
 * Retirer un rattachement
 *
 * La ligne du rattachement RESTE, datée. Retirer le dernier rattachement ferme les relations de la personne et lui envoie un email portant le nom de la structure ; retirer un rattachement parmi plusieurs ne ferme rien. La personne garde l’accès à son historique et à son espace de fichiers, et tout geste de cours lui est refusé.
 */
export const retirerUnRattachement = (options) => (options.client ?? client).delete({ url: '/api/v1/provisionnement/rattachements/{id}', ...options });
/**
 * Créer un compte qui tient l’espace d’une structure
 *
 * Le compte qui voit tout, et lui seul : une structure ne peut pas s’en ajouter un elle-même. Un orgadmin porte au plus un rattachement, et une même personne ne tient pas l’espace de deux structures — il lui faut deux comptes et deux adresses distinctes, que le produit ne relie jamais.
 */
export const creerUnOrgadmin = (options) => (options.client ?? client).post({
    url: '/api/v1/structures/{id}/orgadmins',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Créer un cours
 *
 * Trois chemins convergent ici : le tuteur depuis son espace, une structure par son secret, et l’acceptation d’une demande d’élève. La relation entre le tuteur et chaque élève est le préalable, y compris pour le compte qui voit tout. Un tuteur ne détient pas plus de deux cours non terminés. Un lien d’auto-connexion par participant part par email, tuteur compris, sans nommer les autres participants.
 */
export const creerUnCours = (options) => (options.client ?? client).post({
    url: '/api/v1/cours',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Modifier le titre ou la description d’un cours
 *
 * Le tuteur du cours, un orgadmin sur les cours PORTANT SA STRUCTURE, et le compte qui voit tout. La structure du cours est celle de son tuteur : c’est elle qui décide ce qu’un orgadmin gouverne, et jamais qui voit le cours.
 */
export const modifierUnCours = (options) => (options.client ?? client).patch({
    url: '/api/v1/cours/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Ajouter un participant en cours de route
 *
 * Le tuteur du cours, et lui seul. Un élève peut le lui demander, et il reste seul à décider. Deux gardes, et ce sont des gardes et non des déclencheurs : la relation doit exister, l’ajout ne la crée pas au passage, et le plafond d’élèves ne doit pas être atteint. L’accès part par email à la personne ajoutée seule.
 */
export const ajouterUnParticipant = (options) => (options.client ?? client).post({
    url: '/api/v1/cours/{id}/participants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Entrer dans un cours, ou y revenir
 *
 * Chemin permanent depuis son espace, tant que le cours vit. Une personne n’est présente que dans un cours à la fois : l’entrée dans un second est refusée, et le refus ne dit ni lequel ni avec qui. Entrer dans un cours, c’est entrer dans son canal de visio, sans geste séparé.
 */
export const entrerDansUnCours = (options) => (options.client ?? client).post({ url: '/api/v1/cours/{id}/entree', ...options });
/**
 * Quitter un cours
 *
 * Un élève quitte de lui-même, le tuteur le voit partir, et il peut revenir juste après depuis son espace. Le départ du dernier participant ferme le cours après deux minutes, et c’est le passage automatique qui le fait.
 */
export const sortirDUnCours = (options) => (options.client ?? client).post({ url: '/api/v1/cours/{id}/sortie', ...options });
/**
 * Terminer un cours
 *
 * Le tuteur du cours, un orgadmin sur les cours portant sa structure, le compte qui voit tout. Les présents voient le même message quel que soit le motif : une coupure par un administrateur ne se distingue de rien. Le tableau reste consultable pour la durée applicable à ce cours, écrite sur chaque scène à cet instant. Un secret de structure ne coupe pas un cours.
 */
export const terminerUnCours = (options) => (options.client ?? client).post({ url: '/api/v1/cours/{id}/fin', ...options });
/**
 * Répondre à la fenêtre d’inactivité
 *
 * La fenêtre regarde le cours et s’affiche à tout le monde en même temps ; la réponse est individuelle, et qui ne répond pas dans les cinq minutes est déconnecté tandis que les autres restent. Répondre repousse la fenêtre POUR TOUT LE COURS. Le sursis n’est pas un état : la personne reste présente.
 */
export const repondreALaFenetreDInactivite = (options) => (options.client ?? client).post({ url: '/api/v1/cours/{id}/inactivite/reponse', ...options });
/**
 * Demander un cours à un tuteur
 *
 * Une seule demande en attente à la fois, portée par l’élève, tous fils confondus : pour en adresser une autre, il annule celle qui attend. Le même chemin sert à proposer un cours neuf et à demander à rejoindre un cours déjà commencé. La demande vit dans la conversation qu’elle nomme, et c’est sur elle que se lit le cloisonnement de ses deux champs de texte.
 */
export const creerUneDemandeDeCours = (options) => (options.client ?? client).post({
    url: '/api/v1/demandes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Accepter ou refuser une demande de cours
 *
 * Le tuteur destinataire, et lui seul. Un refus est sec : le produit n’a pas de champ de motif. À l’acceptation, le cours porte le titre et la description que le tuteur saisit, et aucun des deux champs de la demande n’y est recopié. Les deux gardes de l’ajout s’appliquent : relation existante, plafond d’élèves non atteint.
 */
export const repondreAUneDemandeDeCours = (options) => (options.client ?? client).post({
    url: '/api/v1/demandes/{id}/reponse',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Retirer sa demande de cours
 *
 * L’élève auteur, et lui seul. Aucune modification après envoi : le geste existe déjà, l’élève annule et renvoie autant de fois qu’il le veut. Un tuteur ne peut pas bloquer les demandes de quelqu’un : le seul moyen d’arrêter des demandes répétées est qu’un orgadmin défasse la relation.
 */
export const annulerUneDemandeDeCours = (options) => (options.client ?? client).delete({ url: '/api/v1/demandes/{id}', ...options });
/**
 * Obtenir le droit d’entrer dans le canal de visio du cours
 *
 * Une personne présente dans le cours, et elle seule. Le droit vaut dix minutes, se redemande tant qu’elle est présente, ne survit ni à la fin du cours ni à la perte de l’accès, et ne vaut jamais pour un autre cours. Un cours sans canal rend une réponse qui le dit, et ce n’est pas une erreur : le cours continue sur le tableau.
 */
export const obtenirLeDroitDEntreeAuCanal = (options) => (options.client ?? client).post({ url: '/api/v1/cours/{id}/canal/droit', ...options });
/**
 * Couper le micro, la caméra ou le partage d’écran d’un participant
 *
 * Le tuteur du cours, et lui seul. Il n’existe aucun geste pour ALLUMER le flux d’une autre personne, quel que soit le rôle : couper retire, allumer expose. Une coupure imposée ne modifie pas la préférence de la personne coupée, et elle peut se rallumer immédiatement. Le geste laisse une ligne ; couper son propre flux n’en laisse aucune et ne passe pas par ici.
 */
export const couperLeFluxDUnParticipant = (options) => (options.client ?? client).post({
    url: '/api/v1/cours/{id}/flux/{personneId}/coupure',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Signaler que le canal de visio est tombé
 *
 * Rapportée par le poste qui revient, par un appel ordinaire d’une personne connectée : le service extérieur n’appelle jamais le produit. La chute de la visio seule ne fait sortir personne, ne ferme aucun cours et ne laisse aucune ligne au relevé de présence — la présence se juge sur le tableau seul. Aucun email ne part pour une chute.
 */
export const signalerUneChuteDeCanal = (options) => (options.client ?? client).post({ url: '/api/v1/cours/{id}/canal/chute', ...options });
/**
 * Relire son espace de fichiers
 *
 * Les trois régimes de dossiers en une réponse : les siens, les deux tenus par le produit — reconnaissables à leur sorte —, et les dossiers reçus, dans un emplacement à part. La jauge accompagne le tout : elle est visible chaque fois qu’on ouvre l’espace, sans aucun seuil d’avertissement intermédiaire, et la personne est la seule à voir sa consommation. Parcourir ne laisse aucune ligne de trace.
 */
export const relireLespace = (options) => (options?.client ?? client).get({ url: '/api/v1/espace', ...options });
/**
 * Créer un dossier
 *
 * À la racine de son espace, ou dans un dossier — le sien, ou un dossier reçu, car le destinataire d’un partage écrit DANS le dossier. Un sous-dossier créé dans un dossier reçu appartient au PROPRIÉTAIRE du dossier, jamais à celui qui le crée. La profondeur est illimitée.
 */
export const creerUnDossier = (options) => (options.client ?? client).post({
    url: '/api/v1/espace/dossiers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Supprimer un dossier
 *
 * PROPRIÉTAIRE SEUL, et la suppression est IMMÉDIATE : aucune corbeille, aucun délai, aucune récupération, aucune ligne de trace. Les sous-dossiers et les fichiers partent avec, y compris ceux qu’un destinataire de partage y avait déposés — ce contenu appartient au propriétaire du dossier.
 */
export const supprimerUnDossier = (options) => (options.client ?? client).delete({ url: '/api/v1/espace/dossiers/{id}', ...options });
/**
 * Renommer ou déplacer un dossier
 *
 * PROPRIÉTAIRE SEUL : le destinataire d’un partage écrit dans le dossier, jamais sur lui. Un dossier tenu par le produit ne bouge pas. Un dossier ne peut pas entrer dans un dossier reçu d’autrui, ce qui lui ferait changer de propriétaire. Un dossier partagé qui se déplace GARDE son partage.
 */
export const modifierUnDossier = (options) => (options.client ?? client).patch({
    url: '/api/v1/espace/dossiers/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Déposer un ou plusieurs fichiers dans un dossier
 *
 * Propriétaire du dossier, ou destinataire d’un partage sur ce dossier. LE PATRON EST LA CRÉATION PARTIELLE AVEC SIGNALEMENT, et non l’atomicité : quand un fichier du lot est refusé, les autres entrent, et le produit nomme ceux qui n’ont pas pu, avec leur raison. AUCUN TYPE N’EST REFUSÉ — la liste des types refusés existe et elle est vide —, et le type réel est lu dans la signature binaire, jamais dans l’extension annoncée. AUCUNE TAILLE MAXIMUM PAR FICHIER : seul le plafond de l’espace borne, et il est imputé au PROPRIÉTAIRE du dossier, jamais au déposant. Le dépôt direct est interdit dans les deux dossiers tenus par le produit. Aucune ligne de trace, ici comme sur toute action du Drive.
 */
export const deposerDesFichiers = (options) => (options.client ?? client).post({
    ...formDataBodySerializer,
    url: '/api/v1/espace/dossiers/{id}/fichiers',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});
/**
 * Obtenir le lien de téléchargement d’un fichier
 *
 * Propriétaire du dossier, ou destinataire d’un partage : on prend dans un dossier reçu comme dans les siens, sous-dossiers compris. LA RÉPONSE EST UN DROIT D’ACCÈS TRANSFÉRABLE et de courte durée : quiconque l’obtient accède au fichier sans authentification, jusqu’à expiration. Elle ne se met pas en cache et ne se partage pas. Le contenu est servi depuis un domaine sans cookies, le type y est forcé à celui DÉTECTÉ, et tout ce qui n’est pas une image part en pièce jointe — le produit ne visionne aucun document. AUCUNE ADRESSE PUBLIQUE N’EST FABRIQUÉE.
 */
export const lienDuFichier = (options) => (options.client ?? client).get({ url: '/api/v1/espace/fichiers/{id}/contenu', ...options });
/**
 * Supprimer un fichier
 *
 * Deux droits et deux seulement : le propriétaire du dossier, et le déposant pour ce qu’il a lui-même déposé. Le poids retiré rend sa place au propriétaire du dossier, jamais au déposant.
 */
export const supprimerUnFichier = (options) => (options.client ?? client).delete({ url: '/api/v1/espace/fichiers/{id}', ...options });
/**
 * Partager un dossier
 *
 * PROPRIÉTAIRE SEUL, et seulement avec des personnes en relation. On partage à plusieurs en un geste, et le produit crée autant de partages DISTINCTS, retirables séparément. Le dossier donne accès à tout ce qu’il contient, sous-dossiers compris, et ce qui y entre plus tard est partagé aussi, sans geste nouveau. Aucun email ne part.
 */
export const partagerUnDossier = (options) => (options.client ?? client).post({
    url: '/api/v1/espace/dossiers/{id}/partages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Retirer un partage
 *
 * CELUI QUI A PARTAGÉ, SEUL. Le retrait est immédiat, porte sur le dossier et tout son contenu, et NE REND RIEN au destinataire de ce qu’il y avait déposé. Aucun email ne part : personne n’est prévenu qu’il a perdu l’accès à ce qu’il consultait.
 */
export const retirerUnPartage = (options) => (options.client ?? client).delete({ url: '/api/v1/espace/partages/{id}', ...options });
/**
 * Lire le fil d’une conversation
 *
 * PAGINATION PAR CURSEUR SUR LE RANG, qui est unique par conversation. Un message porte trois faits : présent, corrigé ou retiré. Un message retiré garde sa marque sans son contenu — « l’autre a possiblement déjà lu, et effacer sans trace laisserait réécrire ce qu’elle a vu, dans la seule surface du produit que personne ne peut auditer ».
 */
export const lireLeFil = (options) => (options.client ?? client).get({ url: '/api/v1/conversations/{id}/messages', ...options });
/**
 * Envoyer un message, avec ou sans fichiers
 *
 * ENVOI MULTIPART : le texte et les fichiers voyagent dans le MÊME appel, et c’est le produit qui range les fichiers dans le dossier qu’il tient, dans VOTRE espace. Il n’en existe qu’un seul exemplaire, chez l’envoyeur : les autres le lisent depuis la conversation, et rien ne pèse dans leur plafond. UN MESSAGE NE NAÎT JAMAIS VIDE — sans texte ni fichier, l’envoi est refusé, et c’est ce qui permet de reconnaître un message retiré. Un lot dont un fichier est refusé fait entrer les autres, et le message part quand même.
 */
export const envoyerUnMessage = (options) => (options.client ?? client).post({
    ...formDataBodySerializer,
    url: '/api/v1/conversations/{id}/messages',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});
/**
 * Retirer son message
 *
 * AUTEUR SEUL, sans limite de temps, immédiat et sans corbeille. La conversation étant partagée, le retrait fait disparaître le message POUR TOUS. LA MARQUE RESTE, sans le contenu. Personne ne retire le message d’un autre, pas même le tuteur. Vos fichiers ne sont PAS supprimés : ils restent dans votre espace — retirer un message n’est pas renoncer à ses fichiers.
 */
export const retirerUnMessage = (options) => (options.client ?? client).delete({ url: '/api/v1/messages/{id}', ...options });
/**
 * Corriger son message, sous cinq minutes
 *
 * AUTEUR SEUL, et dans les cinq minutes qui suivent l’envoi. Passé ce délai, le texte ne se change plus. LE TEXTE D’AVANT N’EST PAS CONSERVÉ et la conversation ne montre que le FAIT de la correction : « c’est le seul endroit du produit où quelqu’un peut changer ce qu’un autre a déjà lu, et le produit le dit ». L’instant d’envoi ne bouge pas.
 */
export const corrigerUnMessage = (options) => (options.client ?? client).patch({
    url: '/api/v1/messages/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Réagir à un message
 *
 * UNE réaction par personne et par message, choisie dans la liste fermée tenue par le produit — jamais un texte libre. Le geste REMPLACE la précédente, et une valeur vide la retire. La liste vit dans le contrat et non en base : un ajout est un changement de contrat, jamais une migration.
 */
export const poserUneReaction = (options) => (options.client ?? client).put({
    url: '/api/v1/messages/{id}/reaction',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Poser son état de vue
 *
 * UN SEUL CHAMP, le rang du dernier message lu : le compte des non-lus et l’indicateur de lecture s’en dérivent tous les deux. IL NE RECULE JAMAIS — des non-lus ressusciteraient, et l’indicateur de lecture de l’autre se retournerait sur un fait passé. AUCUN INSTANT n’est enregistré : l’autre voit qu’on a lu, jamais « lu à 18h04 ».
 */
export const poserLaLecture = (options) => (options.client ?? client).put({
    url: '/api/v1/conversations/{id}/lecture',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Régler la notification de cette conversation
 *
 * C’est une EXCEPTION qui surcharge votre préférence générale, jamais la préférence elle-même : elle ne vaut que pour cette conversation. Une valeur vide retire l’exception et rend la conversation à votre préférence — un booléen seul ne saurait pas dire « je n’ai pas d’avis ».
 */
export const poserLaNotification = (options) => (options.client ?? client).put({
    url: '/api/v1/conversations/{id}/notification',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Lire la présence de son périmètre
 *
 * Trois valeurs, et il n’y en a pas d’autre : absent, connecté, occupé. PERSONNE NE PEUT SE RENDRE INVISIBLE — aucun mode indisponible, aucun masquage. Un tuteur et un élève lisent leurs relations, une structure ses propres personnes et elles seules, le compte qui voit tout le parc entier. AUCUNE ÉCRITURE, POUR PERSONNE, et AUCUN AGRÉGAT : aucun compte de personnes connectées n’existe. « connecté » est rendu depuis le LOT-4a, le canal temps réel étant livré. La demande de cours reste possible sur un tuteur occupé, et c’est le second usage de cette route.
 */
export const lireLaPresence = (options) => (options?.client ?? client).get({ url: '/api/v1/presence', ...options });
/**
 * Rendre le tableau vivant d’un cours, ou en ouvrir un neuf
 *
 * RENDS-LE OU CRÉE-LE : la route rend le tableau vivant du cours, et n’en ouvre un neuf que si le cours n’en porte aucun ou si le sien est au plafond de poids. Le champ « cree » dit lequel des deux a eu lieu. N’importe quel présent l’exerce, et le premier qui accepte débloque le cours pour tout le monde : c’est le premier geste qu’un élève exerce sur la structure d’un cours. Une ouverture fige le tableau précédent. Au dernier tableau PLEIN, plus rien n’est proposé et le gel reste en place.
 */
export const ouvrirUnTableau = (options) => (options.client ?? client).post({ url: '/api/v1/cours/{id}/tableaux', ...options });
/**
 * Lire le tableau vivant d’un cours, sans en créer aucun
 *
 * La lecture que le contrat n’avait pas : elle rend le tableau vivant du cours avec son poids courant et son plafond, SANS en ouvrir un. Sans elle, la jauge d’un tableau presque plein annonce zéro entre l’arrivée et le premier trait, faute d’une source. Un cours dont la scène a été effacée rend un identifiant vide, ce qui dit à l’appelant qu’il doit en ouvrir un — sans qu’il ait eu à en ouvrir un pour l’apprendre. Réservée aux présents du cours, comme le tracé.
 */
export const lireLeTableauCourant = (options) => (options.client ?? client).get({ url: '/api/v1/cours/{id}/tableau-courant', ...options });
/**
 * Relire la scène d’un tableau
 *
 * Liste fermée de lecteurs : les participants ; les orgadmin d’une structure DONT UN ÉLÈVE ÉTAIT PRÉSENT ; le compte qui voit tout. Jamais la structure du seul tuteur, jamais un tuteur extérieur au cours. La relecture est refusée sur un tableau sans aucun tracé, et elle laisse une ligne de trace quel que soit le lecteur. Les participants d’un cours masqué n’atteignent plus son tableau ; la structure l’atteint encore.
 */
export const relireUneScene = (options) => (options.client ?? client).get({ url: '/api/v1/cours/{id}/tableaux/{rang}', ...options });
/**
 * Poser des tracés ou des pense-bêtes sur le tableau vivant
 *
 * Tout présent. L’auteur vient de la session, jamais du corps, et il est une trace et non un droit : tout le monde efface le tracé de tout le monde. Au plafond de poids, tout ajout est refusé pour TOUS les présents — pas même le tuteur ne trace — et le refus porte la place restante et le besoin. Un poste qui revient d’une coupure de plus de trente secondes ne remplace la version du serveur que si celui-ci n’a rien reçu de personne d’autre.
 */
export const ecrireSurUnTableau = (options) => (options.client ?? client).post({
    url: '/api/v1/tableaux/{id}/contenu',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Mettre à jour un élément déjà posé sur le tableau vivant
 *
 * DÉPLACER, REDIMENSIONNER, RÉÉCRIRE. Sans cette route, la route d’écriture CRÉE et rien ne met à jour : un élément déplacé revient au rechargement là où il est né. L’adressage se fait par l’IDENTITÉ DE NAISSANCE, la seule qu’un poste connaisse d’un élément arrivé par le canal. Tout présent, sur l’élément de n’importe qui, exactement comme le retrait : « tout le monde modifie, déplace et supprime, l’auteur est une trace et pas un droit ». L’AUTEUR NE CHANGE PAS et le GENRE NON PLUS : un tracé ne devient pas un pense-bête. Le poids est recalculé, et une mise à jour qui ferait franchir le plafond est refusée sans rien écrire.
 */
export const mettreAJourSurUnTableau = (options) => (options.client ?? client).patch({
    url: '/api/v1/tableaux/{id}/contenu/{identite}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Retirer un élément du tableau vivant
 *
 * Tout présent, sur l’élément de n’importe qui : un élève peut effacer le travail du tuteur, et le tuteur ne peut pas le récupérer. Ce qui est retiré ne compte plus dans le poids, et l’ajout redevient possible.
 */
export const retirerDuTableau = (options) => (options.client ?? client).delete({ url: '/api/v1/tableaux/{id}/contenu/{elementId}', ...options });
/**
 * Déposer une image ou un PDF sur le tableau
 *
 * Sept chemins d’entrée, et une seule route. Le type réel est contrôlé par la signature binaire, jamais par l’extension annoncée. Un PDF pose toutes ses pages comme images indépendantes et définitives ; un PDF protégé par mot de passe est refusé. La photo prise sur le moment est refusée tant que le canal se sert de la caméra, et le refus nomme le geste qui le lève. Le produit n’émet AUCUN appel sortant vers une adresse fournie par une personne.
 */
export const deposerDesImages = (options) => (options.client ?? client).post({
    ...formDataBodySerializer,
    url: '/api/v1/tableaux/{id}/images',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});
/**
 * Fabriquer le document d’un tableau
 *
 * Le droit de fabriquer suit le droit de relire, sans ligne à lui : l’élève aussi. Tout part, toujours — toutes les cases non vides, aucun choix possible —, et les cases vides sont écartées : le document n’a jamais de page blanche. Il ne porte ni en-tête, ni pied, ni page de garde, ni titre, ni date, ni participants. La fabrication ne laisse aucune trace, et le document ne se fabrique plus une fois la scène effacée.
 */
export const fabriquerLeDocument = (options) => (options.client ?? client).post({ url: '/api/v1/tableaux/{id}/document', ...options });
/**
 * Ranger dans son espace le document fabriqué
 *
 * Second temps du geste : la fabrication rend un nom, celui-ci reçoit les octets et les range. QUATRE BORNES remplacent la garantie que le refus de dépôt direct dans les dossiers tenus portait. La destination est un dossier de SON PROPRE espace, et vaut par défaut le dossier tenu des documents fabriqués ; le dossier des fichiers de conversation est refusé. Le droit de ranger EST le droit de relire, par le même garde, et une scène effacée referme les deux gestes. LE NOM EST CALCULÉ PAR LE SERVEUR et celui de l’envoi n’est pas lu. Et le type est lu dans les octets : ce doit être un document. UN ESPACE PLEIN N’EST PAS UNE ERREUR — le document est téléchargé quand même, il n’est pas rangé, et la réponse le dit.
 */
export const rangerLeDocument = (options) => (options.client ?? client).post({
    ...formDataBodySerializer,
    url: '/api/v1/tableaux/{id}/document/rangement',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});
/**
 * Fermer les cours dont un délai est dépassé
 *
 * Appelée par le serveur d’automatisation du groupe, toutes les deux minutes. Toutes structures confondues. Rejouable : fermer un cours déjà fermé ne fait rien, et le chevauchement de deux passages est acceptable. Aucune identité humaine n’atteint cette route, et le secret de l’automatisation n’en atteint que deux.
 */
export const fermerLesCoursEnRetard = (options) => (options?.client ?? client).post({ url: '/api/v1/interne/cours/fermeture', ...options });
/**
 * Effacer les scènes dont la durée de relecture est écoulée
 *
 * Appelée par le serveur d’automatisation du groupe, toutes les heures — le passage quotidien est écarté, une structure pouvant descendre la durée à un jour. Elle efface les scènes échues ET les fichiers d’image du stockage avec, et laisse la ligne du tableau, vide, avec son rang. Rejouable : effacer une scène déjà effacée ne fait rien.
 */
export const effacerLesScenesEchues = (options) => (options?.client ?? client).post({ url: '/api/v1/interne/scenes/effacement', ...options });
/**
 * Lire son historique de cours
 *
 * UNE LIGNE PAR COURS TERMINÉ, DU PLUS RÉCENT AU PLUS ANCIEN, et l’ordre est UNIQUE ET NON RÉGLABLE : il n’y a ni tri, ni filtre par date, par structure ou par état. Un tuteur ne voit que ses cours ; un élève voit tous les siens, TOUS TUTEURS ET TOUTES STRUCTURES CONFONDUS. Deux durées par ligne, et c’est voulu : la vôtre, et celle de co-présence du cours — sur un cours groupé elles diffèrent pour presque tout le monde. UN COURS MASQUÉ N’Y FIGURE PAS, sans trace et sans place vide. La liste se charge par tranches SANS PLAFOND : rien ne se tronque, une ligne se conserve pour toujours. Parcourir cet écran ne laisse AUCUNE ligne de trace ; ouvrir la scène d’un cours en laisse une.
 */
export const lireLHistorique = (options) => (options?.client ?? client).get({ url: '/api/v1/historique', ...options });
/**
 * Lire son écran d’arrivée
 *
 * DEUX ÉCRANS SOUS UNE ROUTE, et la réponse se discrimine par le rôle. ÉLÈVE, trois blocs : ses cours en train de se dérouler, ses tuteurs avec leur état de présence, ses derniers cours. TUTEUR, quatre blocs : ses cours non terminés avec le compteur du plafond de deux, les demandes reçues AVEC LEURS DEUX TEXTES, ses élèves avec leur présence, ses derniers cours. CET ÉCRAN N’EST PAS L’HISTORIQUE, et LE TOTAL DU TEMPS DE COURS NE S’Y AFFICHE PAS — il vit sur /api/v1/historique et nulle part ailleurs. AUCUN CLASSEMENT, AUCUN BADGE, AUCUNE SÉRIE, aucun compteur de nouveautés : rien ici n’est un objet conservé, tout se calcule à l’instant. Le champ accesPerdu distingue « aucun cours » de « AUCUN COURS POSSIBLE ».
 */
export const lireLArrivee = (options) => (options?.client ?? client).get({ url: '/api/v1/arrivee', ...options });
/**
 * Lire son annuaire, fondu avec ses conversations
 *
 * UNE SEULE SURFACE, PAS DEUX : « le produit ne met en relation que des personnes avec qui on peut parler, donc deux listes porteraient exactement les mêmes lignes ». UNE LIGNE PAR RELATION, portant le prénom du correspondant, son état de présence, le dernier message et son instant, et le nombre de non-lus. C’EST LE SEUL INVENTAIRE DE CONVERSATIONS DU PRODUIT depuis le 20260829 : GET /api/v1/conversations est retirée, elle lisait le même inventaire par le même code, et F-50 pose qu’« il n’y a pas deux inventaires de conversations ». IL N’Y A PAS DE FICHE D’UNE PERSONNE — une ligne, et rien derrière. LE PARTAGE D’UN DOSSIER NE PART PAS D’ICI : il part du dossier, un second chemin ferait deux gestes pour une seule décision. UNE RELATION FERMÉE DISPARAÎT, et l’écran ne dit jamais pourquoi.
 */
export const lireLAnnuaire = (options) => (options?.client ?? client).get({ url: '/api/v1/annuaire', ...options });
/**
 * Lire ses réglages
 *
 * LES QUATRE RÔLES, ET ILS N’Y VOIENT PAS LA MÊME CHOSE. Un tuteur ou un élève y trouve son adresse, ses TROIS préférences et le nombre de conversations qui portent une exception de notification. UN ORGADMIN ET LE COMPTE QUI VOIT TOUT N’Y TROUVENT QUE LEUR ADRESSE : ils n’ont ni cours, ni espace de fichiers, ni conversation, donc les trois préférences n’auraient aucun objet. La réponse se discrimine par ce fait. AUCUN RÉGLAGE DE LANGUE : français seul, et le modèle ne porte aucune colonne de langue.
 */
export const lireLesReglages = (options) => (options?.client ?? client).get({ url: '/api/v1/reglages', ...options });
/**
 * Régler une de ses trois préférences
 *
 * TROIS PRÉFÉRENCES, LISTE FERMÉE : media (micro et caméra), rangement (où se range un document fabriqué), notification (email à la réception d’un message). LE CHEMIN DÉCIDE LAQUELLE, et un champ qui n’appartient pas à la préférence nommée est REFUSÉ, jamais ignoré — ignorer ferait croire que le réglage a pris. L’ÉCRAN N’EST PAS LE SEUL CHEMIN : couper sa caméra pendant un cours et choisir un dossier en fabriquant un document continuent de valoir, « le geste reste le chemin court, l’écran est le chemin qui existe hors de l’occasion ». L’EXCEPTION DE NOTIFICATION D’UNE CONVERSATION NE SE RÈGLE PAS ICI : elle se règle dans la conversation.
 */
export const poserUnePreference = (options) => (options.client ?? client).put({
    url: '/api/v1/reglages/preferences/{nom}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Remettre toutes ses conversations au réglage général
 *
 * UN GESTE UNIQUE POUR TOUTES. L’écran des réglages ne porte que le NOMBRE de conversations qui portent une exception, jamais leur liste — « lister les conversations ici referait la surface de l’annuaire une seconde fois ». Ce geste existe parce que SANS LUI, UN FIL COUPÉ SIX MOIS PLUS TÔT NE SE RETROUVE PLUS. L’exception se RETIRE, elle ne se met pas à faux : un booléen seul ne saurait pas dire « je n’ai pas d’avis ».
 */
export const remettreLesExceptions = (options) => (options?.client ?? client).post({ url: '/api/v1/reglages/preferences/notification/reinitialisation', ...options });
/**
 * Lire ses rattachements, actifs et terminés
 *
 * ACTIFS ET TERMINÉS, AVEC LEURS DATES. Un rattachement retiré LAISSE SA LIGNE, datée : elle ne se supprime pas. C’EST LEUR SEULE SURFACE, et ils conditionnent tout votre accès — les montrer est ce qui REND EXPLICABLE UN ESPACE QUI NE PEUT RIEN. VOS RELATIONS NE FIGURENT PAS ICI : elles ont leur surface, l’annuaire.
 */
export const lireLesRattachements = (options) => (options?.client ?? client).get({ url: '/api/v1/reglages/rattachements', ...options });
/**
 * Lire ses adresses passées
 *
 * EN LECTURE, avec la date de chaque changement. C’EST LE SEUL ENDROIT OÙ VOUS POUVEZ LES REGARDER, aucun export de vos propres données n’existant en V1. VOUS N’EN RETIREZ AUCUNE, et il n’existe aucune route pour le faire : le produit les garde pour CONTINUER À VOUS RECONNAÎTRE quand une structure vous provisionne avec l’adresse qu’elle connaît. Une adresse y entre AU MOMENT où le changement prend effet, jamais à la demande.
 */
export const lireLesAdressesPassees = (options) => (options?.client ?? client).get({ url: '/api/v1/reglages/adresses-passees', ...options });
/**
 * Fermer toutes ses connexions sauf celle-ci
 *
 * UN SEUL GESTE, ET IL EXIGE LE MOT DE PASSE COURANT. CELLE D’OÙ VOUS AGISSEZ RESTE OUVERTE. IL N’Y A PAS DE FERMETURE LIGNE PAR LIGNE, et c’est une décision : « distinguer une connexion étrangère d’une des siennes sur une adresse réseau et un nom d’appareil n’est pas quelque chose qu’une personne sait faire ; un geste unique est ACTIONNABLE SANS INTERPRÉTATION ». C’EST LE SEUL LEVIER DU PRODUIT CONTRE UNE SESSION REPRISE — une session vaut sept jours, et sans ce geste la reprise durait sept jours quoi qu’il arrive. CE GESTE LAISSE UNE LIGNE DE TRACE, la seule de cet écran.
 */
export const fermerLesConnexions = (options) => (options.client ?? client).delete({
    url: '/api/v1/reglages/connexions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Lire ses connexions en cours
 *
 * LA DATE, L’APPAREIL OU LE NAVIGATEUR, L’ADRESSE RÉSEAU. Le produit les conserve sans limite, et C’EST LE SEUL ENDROIT OÙ VOUS POUVEZ LES REGARDER. LE JETON N’EN SORT JAMAIS : c’est l’un des cinq secrets qui ne se relisent pas, et il n’est même pas chargé. Le compte qui voit tout lit ces lignes et n’en ferme aucune.
 */
export const lireLesConnexions = (options) => (options?.client ?? client).get({ url: '/api/v1/reglages/connexions', ...options });
/**
 * Lister les structures du parc
 *
 * LE COMPTE QUI VOIT TOUT SEUL. C’est son écran d’arrivée — « l’écran d’arrivée est asymétrique par rôle » — et c’est aussi ce que consomme le sélecteur permanent de tête de surface. LA PERSONNE QUI TIENT UN ESPACE N’A PAS DE SÉLECTEUR, portant au plus un rattachement : il n’aurait qu’une ligne. AUCUNE LIGNE DE TRACE : parcourir une liste n’en laisse aucune, seule l’ouverture d’une fiche en laisse une.
 */
export const listerLesStructures = (options) => (options?.client ?? client).get({ url: '/api/v1/admin/structures', ...options });
/**
 * Créer une structure, et émettre son secret d’appel
 *
 * LE COMPTE QUI VOIT TOUT, SEUL, et le geste laisse sa trace. LA CRÉATION PASSE PAR CETTE ROUTE ET PAR ELLE SEULE (Q566) : CDC-1 en portait un second chemin, il est retiré — « deux chemins pour un geste font deux autorisations à tenir d’accord, et celle qu’on oublie est la faille ». LA RÉPONSE PORTE LA VALEUR DU SECRET, ET C’EST LA SEULE FOIS : elle ne se réaffiche jamais, la base n’en portant que l’empreinte. Aucun email ne part ; la transmission se fait hors du produit.
 */
export const creerUneStructure = (options) => (options.client ?? client).post({
    url: '/api/v1/admin/structures',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Ouvrir la fiche d’une structure
 *
 * LES DEUX RÔLES, ET ILS NE LISENT PAS LE MÊME OBJET. Le compte qui voit tout reçoit la fiche entière ; une personne qui tient un espace reçoit TROIS CHAMPS de SA structure, les six colonnes d’affichage lui étant fermées Y COMPRIS LES SIENNES, ainsi que tout ce qui en dérive dont « paraît sur le site ». L’EMPREINTE DU SECRET NE SORT À AUCUN DES DEUX : ce qui sort est « secretEmis », un booléen dérivé. CETTE OUVERTURE LAISSE UNE LIGNE DE TRACE, et c’est la seule lecture de cette surface qui en laisse une.
 */
export const lireUneStructure = (options) => (options.client ?? client).get({ url: '/api/v1/admin/structures/{id}', ...options });
/**
 * Modifier le nom interne d’une structure
 *
 * LE COMPTE QUI VOIT TOUT MODIFIE LE NOM INTERNE. LA STRUCTURE NE LE MODIFIE PAS. C’est le seul champ que cette route touche : les colonnes d’affichage ont la leur, les réglages la leur, et le secret ne se modifie pas — il se régénère ou se révoque.
 */
export const renommerUneStructure = (options) => (options.client ?? client).patch({
    url: '/api/v1/admin/structures/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Régénérer le secret d’appel d’une structure
 *
 * LE COMPTE QUI VOIT TOUT SEUL, ET IL NE RELIT JAMAIS LA VALEUR ANCIENNE. Régénérer, c’est ÉCRASER L’EMPREINTE, SANS PÉRIODE DE RECOUVREMENT : l’ancienne valeur est invalide IMMÉDIATEMENT, et aucun email ne part — « la structure le découvre par l’erreur de son prochain appel ». LES DEUX SEULES OCCASIONS DE LE CHANGER SONT LE SECRET PERDU ET LE SOUPÇON DE FUITE : aucune rotation périodique n’existe (Q554). Sa portée est sa structure seule, jamais le parc : une clé partagée n’existe pas ici.
 */
export const regenererLeSecretDappel = (options) => (options.client ?? client).post({ url: '/api/v1/admin/structures/{id}/secret/regeneration', ...options });
/**
 * Révoquer le secret d’appel d’une structure
 *
 * LE COMPTE QUI VOIT TOUT SEUL. Révoquer, c’est VIDER LE CHAMP : la structure n’a plus de secret, ses appels échouent dès maintenant, et aucun email ne l’en prévient. C’est le DERNIER geste de l’ordre d’extinction de F-68, et l’ordre n’est pas indifférent. CETTE ROUTE NE SUPPRIME PAS LA STRUCTURE : aucun geste de suppression n’existe.
 */
export const revoquerLeSecretDappel = (options) => (options.client ?? client).delete({ url: '/api/v1/admin/structures/{id}/secret', ...options });
/**
 * Remplir les six colonnes d’affichage d’une structure
 *
 * LE COMPTE QUI VOIT TOUT LES REMPLIT SEUL. La personne qui tient l’espace N’EN LIT NI N’EN ÉCRIT AUCUNE, Y COMPRIS LES SIENNES : refus explicite (Q513). AUCUNE SAISIE EN MASSE : une structure à la fois. C’EST UN PUT, donc il décrit l’état COMPLET des colonnes — une chaîne vide vide la colonne. TROIS D’ENTRE ELLES DÉCLENCHENT LA PRÉSENCE sur le site public — logo, nom de marque, au moins un couple chiffre et libellé — et EN VIDER UNE EST LE SEUL GESTE QUI RETIRE UNE STRUCTURE DU SITE : « aucun geste retirer du site n’existe, la présence étant dérivée et jamais stockée ». Le type réel du logo est lu PAR SIGNATURE BINAIRE.
 */
export const poserLesColonnesDaffichage = (options) => (options.client ?? client).put({
    ...formDataBodySerializer,
    url: '/api/v1/admin/structures/{id}/colonnes-affichage',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});
/**
 * Lister les comptes rattachés à une structure
 *
 * LES DEUX RÔLES, l’orgadmin sur SA structure. LA LISTE EST L’ÉCRAN, ordonnée PAR DATE DE RATTACHEMENT, du plus récent au plus ancien, ORDRE UNIQUE ET NON RÉGLABLE — et ce n’est pas cosmétique : cet ordre REMPLACE l’alerte email supprimée en Q114, « on voit les comptes qui viennent d’être créés en ouvrant la liste, pas en recevant un email ». Aucun badge, aucun compteur de nouveautés. LA PRÉSENCE EN LIGNE FIGURE SUR CHAQUE LIGNE, une personne à la fois et SANS TRACE : aucun agrégat n’existe. Les rattachements RETIRÉS y figurent avec leur date de fin. AUCUNE LIGNE DE TRACE : parcourir une liste n’en laisse aucune.
 */
export const listerLesComptesDuneStructure = (options) => (options.client ?? client).get({ url: '/api/v1/admin/structures/{id}/comptes', ...options });
/**
 * Ouvrir la fiche d’un compte
 *
 * LES DEUX RÔLES, l’orgadmin sur une personne rattachée à SA structure. ELLE PORTE CE QUE LA LIGNE NE PORTE PAS : les autres rattachements, les relations extérieures, les adresses passées. LES DEUX PREMIERS SONT DES DONNÉES QUE LA STRUCTURE NE POSSÈDE PAS, ET C’EST ASSUMÉ : ce sont les deux brèches VOULUES du cloisonnement (Q123, Q124), pas un défaut. CETTE OUVERTURE LAISSE UNE LIGNE DE TRACE. Ne sortent jamais : l’empreinte de mot de passe, les codes de vérification, les liens d’auto-connexion en cours, les préférences — et ni l’espace de fichiers ni les conversations, entièrement fermés aux deux rôles.
 */
export const lireLaFicheDunCompte = (options) => (options.client ?? client).get({ url: '/api/v1/admin/comptes/{id}', ...options });
/**
 * Modifier un compte
 *
 * LE COMPTE QUI VOIT TOUT SEUL, sur toutes les structures, et l’action est tracée. IL NE CHANGE JAMAIS UNE ADRESSE EMAIL — borne acquise au domaine des accès et non élargie ici : le champ N’EXISTE PAS dans ce corps, et un corps qui le porterait reçoit 400 plutôt que de le voir ignoré. Le seul chemin d’une adresse est celui de son titulaire, mot de passe courant PUIS code à la nouvelle adresse. UNE STRUCTURE N’ATTEINT PAS CETTE ROUTE : « une structure ne touche jamais un compte », changer le rôle d’une personne le changerait chez toutes ses structures.
 */
export const modifierUnCompte = (options) => (options.client ?? client).patch({
    url: '/api/v1/admin/comptes/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Rattacher à une structure une personne qui existe déjà
 *
 * LES DEUX RÔLES, l’orgadmin sur SA structure. « UNE STRUCTURE RATTACHE ET DÉTACHE, ELLE NE CRÉE PAS » : cette route ne crée AUCUN compte, et une personne inconnue est refusée plutôt que créée en silence. C’est ce qui la distingue de POST /api/v1/provisionnement/comptes, qui crée-ou-reconnaît par l’adresse et n’est pas ouverte à un orgadmin. UNE STRUCTURE NE TOUCHE JAMAIS UN COMPTE : ce corps ne porte ni nom, ni prénom, ni adresse, ni rôle. UN COMPTE ORGADMIN PORTE AU PLUS UN RATTACHEMENT (Q534), et son identifiant externe est toujours vide (Q533). Le compte qui voit tout n’en porte jamais aucun (Q535).
 */
export const rattacherUnePersonne = (options) => (options.client ?? client).post({
    url: '/api/v1/admin/structures/{id}/rattachements',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Lister les cours d’une structure et la somme de ses minutes
 *
 * LES DEUX RÔLES, l’orgadmin sur SA structure. UN COURS N’Y FIGURE QUE S’IL PORTE AU MOINS UN ÉLÈVE DE LA STRUCTURE, « même si son tuteur lui est rattaché » : le contenu d’une séance lui est ouvert PAR SES ÉLÈVES, jamais par ses tuteurs. UN FILTRE DE DATES EXISTE, ET LA SOMME DES MINUTES LE SUIT — c’est la seule surface du produit où un filtre décide quelque chose, et sans lui aucun mois ne se facture. LA SOMME PORTE SUR TOUTE LA PÉRIODE, pas sur la tranche affichée. Elle compte les cours des comptes anonymisés ET les cours masqués — « le masquage vise la liste d’une personne, jamais la mémoire du parc » — et elle ne baisse jamais rétroactivement. Un cours mixte apparaît dans LES DEUX structures, avec sa durée entière de chaque côté, sans partage ni prorata. TOUT EST CALCULÉ À L’AFFICHAGE : aucun compteur n’est entretenu, et c’est ce qui rend la somme d’une structure éteinte encore lisible.
 */
export const listerLesCoursDuneStructure = (options) => (options.client ?? client).get({ url: '/api/v1/admin/structures/{id}/cours', ...options });
/**
 * Lire le relevé des entrées et des sorties d’un cours
 *
 * LES DEUX RÔLES, et l’orgadmin SUR LES MÊMES COURS QUE SA LISTE — « une structure ne voit jamais les cours de ses tuteurs avec des élèves d’une autre structure ». CE QUE CES LIGNES SONT : la décomposition de la durée que la liste des cours affiche, sur la seule surface du produit dont un chiffre sert de base à une facturation qui se fait hors du produit. LE RÔLE ET LA STRUCTURE DE CHAQUE LIGNE SONT CEUX DU COURS, figés à l’entrée, jamais ceux du compte aujourd’hui : « le rôle du compte peut être vrai aujourd’hui et faux sur un cours d’il y a un an ». LA DURÉE D’UNE LIGNE EST VIDE tant que la personne n’est pas sortie, et la SOMME des durées de lignes N’EST PAS la durée du cours : celle-ci est une co-présence sur des segments qui se recouvrent, et « sur un cours groupé, elles diffèrent pour presque tout le monde ». AUCUNE LIGNE DE TRACE : parcourir un relevé n’en laisse pas. Un cours TERMINÉ porte son relevé — c’est celui-là qu’on relit pour facturer.
 */
export const lireLeReleveDunCours = (options) => (options.client ?? client).get({ url: '/api/v1/admin/cours/{id}/releve', ...options });
/**
 * Masquer un cours
 *
 * LE COMPTE QUI VOIT TOUT EST SEUL À L’AVOIR, et CE GESTE PASSE PAR CETTE SURFACE ET PAR ELLE SEULE (Q566) : CDC-2 en portait un second chemin, il est retiré. LA ROUTE MASQUE, ELLE NE BASCULE PAS : le corpus donne « masquer » et aucun geste de réapparition. CE QUE LE MASQUAGE FAIT, ET CE QU’IL NE FAIT PAS : le cours disparaît de l’historique des participants, et il RESTE dans la liste de sa structure, dans sa somme de minutes et dans le nombre de cours tenus — « le masquage vise la liste d’une personne, jamais la mémoire du parc ».
 */
export const masquerUnCours = (options) => (options.client ?? client).post({ url: '/api/v1/admin/cours/{id}/masquage', ...options });
/**
 * Observer un cours en direct
 *
 * LES DEUX RÔLES, ET AUCUN AUTRE COMPTE RATTACHÉ, TUTEURS COMPRIS. CE GESTE PASSE PAR CETTE SURFACE ET PAR ELLE SEULE (Q566), AVEC SA BORNE DÉCLARÉE ICI (Q567) : une structure n’observe qu’un cours dont UN DE SES ÉLÈVES est présent, sinon AUCUN_ELEVE_DE_CETTE_STRUCTURE. C’est l’item R16 de la revue — les deux anciens chemins ne déclaraient pas la même autorisation, et « une borne qui dépend du chemin emprunté est une faille par construction ». CE QU’ELLE MONTRE : le tableau qui se remplit, les curseurs nommés, les écrans partagés. JAMAIS L’IMAGE NI LE SON, refus explicite aux deux rôles — aucune référence de canal de visio ne sort de cette réponse. LE PASSAGE D’UN ORGADMIN EST SIGNALÉ PAR UN BANDEAU ; celui du compte qui voit tout ne l’est pas, « son passage restant constatable par sa trace ». LES DEUX LAISSENT UNE LIGNE, et c’est un objet à elle, jamais une valeur de la table de trace générale.
 */
export const observerUnCoursEnDirect = (options) => (options.client ?? client).get({ url: '/api/v1/admin/cours/{id}/observation', ...options });
/**
 * Lire les cinq réglages d’une structure
 *
 * LES DEUX RÔLES, l’orgadmin sur SA structure. UN SEUL ÉCRAN PORTE LES CINQ, et la liste est FERMÉE À CINQ : un sixième réglage de structure est une livraison de code. CHAQUE RÉGLAGE PORTE SA VALEUR COURANTE, SA VALEUR PAR DÉFAUT ET SES BORNES — sans la valeur par défaut on ne sait pas s’il a été touché, sans les bornes on découvre la limite par un refus. LE BLOC DU PARC N’EST RENDU QU’AU COMPTE QUI VOIT TOUT : il est ABSENT et non vide pour une structure, une valeur nulle se lisant comme « pas encore réglé » alors qu’il existe dès la mise en service. L’ÉCRAN DIT QUE LES PLAFONDS DE VOLUME SE CUMULENT sur les rattachements d’une personne, et il porte le seul chiffre qu’une structure ait sur les espaces : le nombre de personnes au plafond.
 */
export const lireLesReglagesDuneStructure = (options) => (options.client ?? client).get({ url: '/api/v1/admin/structures/{id}/reglages', ...options });
/**
 * Modifier un réglage de structure
 *
 * LES DEUX RÔLES : la personne qui tient l’espace pour SA structure, le compte qui voit tout pour toutes. CHAQUE MODIFICATION LAISSE SA LIGNE. UN SEUL RÉGLAGE PAR APPEL, son nom dans l’adresse : un corps qui porterait les cinq ferait de chaque écriture une réécriture des quatre autres, et « le dernier gagne, aucun verrou » deviendrait dévastateur. AUCUNE VALEUR HORS BORNES N’EST ACCEPTÉE, ET LE REFUS DIT LA BORNE FRANCHIE. UNE MODIFICATION NE TOUCHE JAMAIS UN COURS EN TRAIN DE SE DÉROULER : les réglages sont lus à l’usage, jamais recopiés sur un cours, donc la règle tient par l’absence de copie.
 */
export const poserUnReglageDeStructure = (options) => (options.client ?? client).put({
    url: '/api/v1/admin/structures/{id}/reglages/{nom}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Lire le réglage du parc
 *
 * LE COMPTE QUI VOIT TOUT SEUL. IL VIT HORS DE TOUTE STRUCTURE, et c’est pourquoi son adresse n’en porte aucune. SON UNITÉ EST L’ÉLÈVE, comme le réglage qu’il plafonne : lire « cinq participants présents » donnerait quatre élèves plus le tuteur, donc une borne plus basse que le défaut d’une structure neuve. CE N’EST PAS UN SIXIÈME RÉGLAGE DE STRUCTURE : c’est un nombre du produit, du même genre que le seuil de six flux d’image, et la liste fermée à cinq tient sans changement.
 */
export const lireLeReglageDuParc = (options) => (options?.client ?? client).get({ url: '/api/v1/admin/parc/reglage', ...options });
/**
 * Modifier le réglage du parc
 *
 * LE COMPTE QUI VOIT TOUT SEUL, et chaque modification laisse sa ligne. IL PLAFONNE LE RÉGLAGE D’UNE STRUCTURE SANS LE REMPLACER : l’orgadmin continue de régler le sien, et le réglage effectif d’un cours est LE PLUS BAS DES DEUX. UNE BAISSE NE TOUCHE PAS UN COURS EN TRAIN DE SE DÉROULER, et LE RÉGLAGE DE LA STRUCTURE N’EST PAS MODIFIÉ — aligner les structures à la baisse serait la chose « utile » à faire, et c’est exactement ce que le cas de bord 7 interdit. CE QU’IL NE CASSE PAS : le régime dégradé de la visio au-delà de six flux reste atteignable, il suffit de relever la borne du parc.
 */
export const poserLeReglageDuParc = (options) => (options.client ?? client).put({
    url: '/api/v1/admin/parc/reglage',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Exporter les comptes rattachés à une structure
 *
 * LES DEUX RÔLES, l’orgadmin sur SA structure, ET LE GESTE LAISSE UNE LIGNE DE TRACE CONSERVÉE. CSV, séparateur point-virgule, encodage universel avec sa marque d’ordre, pour qu’un tableur français l’ouvre sans réglage. UNE LIGNE PAR PERSONNE — jamais par rattachement, qui la ferait compter deux fois — et les listes multiples tiennent dans une seule colonne. AUCUN EN-TÊTE DÉCORATIF, AUCUNE LIGNE DE TOTAL, AUCUNE MISE EN FORME, AUCUN PLAFOND DE LIGNES. IL SORT DES DONNÉES QUE LA STRUCTURE NE POSSÈDE PAS — les autres rattachements et les relations extérieures d’une personne —, ET C’EST ASSUMÉ. SONT EXCLUS : l’empreinte de mot de passe, les codes et liens en cours, et l’empreinte du secret d’appel de la structure. RIEN N’EST STOCKÉ ET AUCUN LIEN À DURÉE DE VIE N’EST ÉMIS : le contenu est rendu en texte, et le navigateur l’enregistre.
 */
export const exporterLesComptes = (options) => (options.client ?? client).get({ url: '/api/v1/admin/structures/{id}/exports/comptes', ...options });
/**
 * Exporter les cours d’une structure
 *
 * LES DEUX RÔLES, ET LE GESTE LAISSE UNE LIGNE DE TRACE CONSERVÉE. UN TUTEUR N’EXPORTE PAS SES PROPRES COURS : c’est un geste de la personne qui tient l’espace, sur son périmètre seul, titre et description compris. SON PÉRIMÈTRE EST CELUI DE LA LISTE DE F-62, et par la même lecture : un cours n’en est que s’il porte au moins un élève de la structure. Même format que l’autre export.
 */
export const exporterLesCours = (options) => (options.client ?? client).get({ url: '/api/v1/admin/structures/{id}/exports/cours', ...options });
/**
 * Lire les chiffres d’exploitation d’une structure
 *
 * LES DEUX RÔLES, l’orgadmin sur SA structure ; le compte qui voit tout les lit sur chaque structure. LES INDICATEURS SE CALCULENT SUR LES COURS OÙ AU MOINS UN ÉLÈVE DE LA STRUCTURE ÉTAIT PRÉSENT, jamais sur ceux de ses seuls tuteurs. TOUT EST CALCULÉ À L’AFFICHAGE : aucun objet suivi, aucun compteur entretenu. DEUX DES CINQ INDICATEURS DU TABLEAU SORTENT VIDES ET NON À ZÉRO — les dépôts refusés faute de place et la part des cours sur tablette n’ont AUCUNE SOURCE AU MODÈLE, et zéro se lirait comme une affirmation que le produit ne peut pas faire. AUCUNE ALERTE, AUCUN SEUIL, AUCUN EMAIL sur ces chiffres.
 */
export const lireLesChiffresDuneStructure = (options) => (options.client ?? client).get({ url: '/api/v1/admin/structures/{id}/chiffres', ...options });
/**
 * Lire les six chiffres réservés au compte qui voit tout
 *
 * LE COMPTE QUI VOIT TOUT SEUL, PARC ENTIER, JAMAIS PAR STRUCTURE. UNE PERSONNE QUI TIENT UN ESPACE NE LES VOIT NULLE PART : refus explicite, et le motif est écrit — une structure ne peut rien sur les liaisons de ses élèves ni sur les sessions de ses personnes, et la seule décision qui s’agit sur ces chiffres, le rejeu du mode de diffusion, appartient au parc. ELLE REÇOIT 403 CHIFFRES_DE_PARC_INTERDITS, JAMAIS UN OBJET VIDE : une absence et un refus se lisent pareil. LA PÉRIODE EST OBLIGATOIRE — sans elle, « nombre de chutes » ou « nombre de fermetures » ne veut rien dire. UN AGRÉGAT N’EST PAS UNE CONSULTATION DE TRACE : aucun écran de consultation n’existe en V1, et seuls les comptes sortent, jamais les lignes.
 */
export const lireLesChiffresDuParc = (options) => (options.client ?? client).get({ url: '/api/v1/admin/parc/chiffres', ...options });
/**
 * Les marques clientes du carrousel de l’accueil
 *
 * Aucune authentification, aucun paramètre, aucune trace. Ne rend que les structures dont LES TROIS colonnes déclencheuses sont remplies — logo, nom d’affichage, et au moins un couple chiffre et libellé —, dans l’ordre de création des structures. Toute autre colonne de la structure est interdite en réponse : son identifiant, son nom interne, l’empreinte de son secret d’appel, ses cinq réglages, ses rattachements, ses comptes, ses relations, ses séances, sa somme de minutes et ses dates. Le tableau est vide quand aucune structure n’est complète : c’est l’état vide du carrousel.
 */
export const lireLesMarquesPubliques = (options) => (options?.client ?? client).get({ url: '/api/v1/public/marques', ...options });
/**
 * Renvoie le message reçu (exemple)
 *
 * Route d'exemple, à supprimer par les projets dérivés. Valide son corps avec le schéma Zod partagé demoEchoSchema.
 */
export const demoEcho = (options) => (options.client ?? client).post({
    url: '/api/v1/demo/echo',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
/**
 * Route fermée (exemple)
 *
 * Aucune @Public() : répond 401 tant qu'aucun module d'authentification n'existe. Sert de démonstration de la fermeture par défaut.
 */
export const demoProtected = (options) => (options?.client ?? client).get({ url: '/api/v1/demo/protected', ...options });
//# sourceMappingURL=sdk.gen.js.map